const recurrrenceOptions = [
  { id: "", name: "Does not repeat" },
  { id: "daily", name: "Daily" },
  { id: "weekly", name: "Weekly" },
  { id: "monthly", name: "Monthly" },
  { id: "custom", name: "Custom" },
];

const daysOptions = [
  { id: "0", name: "Monday" },
  { id: "1", name: "Tuesday" },
  { id: "2", name: "Wednesday" },
  { id: "3", name: "Thursday" },
  { id: "4", name: "Friday" },
  { id: "5", name: "Saturday" },
  { id: "6", name: "Sunday" },
];

function visibleRecurrence(_, record) {
  return ["daily", "weekly", "monthly", "custom"].includes(
    record?.recurrence?.id,
  );
}

function visibleWeekdays(_, record) {
  return ["weekly", "custom"].includes(record?.recurrence?.id);
}

const layout = {
  model: "appointment_scheduling.calendar",
  form_action: ["add", "edit"],
  table_action: ["add", "edit"],
  selectable: null,

  fields: {
    start_date: { type: "datetime", required: true },

    end_date: { type: "datetime", required: true },

    recurrence: {
      type: "selection",
      options: recurrrenceOptions,
      translate: true,
    },

    type: {
      type: "selection",
      options: [
        { id: "availability", name: "Availability" },
        { id: "locking", name: "Locking" },
      ],
      default: "availability",
      translate: true,
      required: true,
    },

    recurrence_end_date: {
      type: "date",
      invisible: (b, r) => !visibleRecurrence(b, r),
    },

    weekdays: {
      type: "multiselection",
      options: daysOptions,
      translate: true,
      invisible: (b, r) => !visibleWeekdays(b, r),
    },

    professional: {
      type: "many2one",
      model: "appointment_scheduling.professional",
    },

    room: {
      type: "many2one",
      model: "appointment_scheduling.room",
    },

    schedule: {
      type: "button",
      button_method: "schedule",
    },

    draft: {
      type: "button",
      button_method: "draft",
    },

    cancel: {
      type: "button",
      button_method: "cancel",
    },

    state: {
      type: "char",
      translate: true,
      default: "draft",
      readOnly: true,
    },

    all_day: {
      type: "boolean",
    },

    notes: {
      type: "text",
    },
  },

  list: [],

  form: [
    { name: "type" },
    { name: "professional" },
    { name: "room" },
    {
      name: "dates",
      type: "grid",
      col: "grid-cols-4",
      elements: [
        { name: "start_date" },
        { name: "end_date" },
        { name: "recurrence" },
        { name: "all_day" },
        { name: "recurrence_end_date" },
        { name: "weekdays" },
        { name: "state" },
      ],
    },
    { name: "notes" },
    {
      name: "buttons",
      type: "grid",
      col: "grid-cols-3",
      elements: [{ name: "schedule" }, { name: "draft" }, { name: "cancel" }],
    },
  ],
};

export default layout;
